var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Quantity } from '@shared/commons/UtilsClasses/Quantity';
import { LOCALE_EN, Resources } from '@shared/localizations/Resources';
import { confirmationScreenHandler, editPositionScreenHandler, messageBoxHandler, modifyOrderScreenHandler, positionExerciseRequestScreenHandler, positionsMutualCloseScreenHandler } from '@shared/utils/AppHandlers';
import { AccountType } from '@shared/utils/cache/Accounts/Account.types';
import { DirectReportMessage } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { Enum } from '@shared/utils/Enum';
import { InstrumentUtils } from '@shared/utils/Instruments/InstrumentUtils';
import { TooltipType } from '@shared/utils/ReportMessageTooltipTypeEnum';
import { ClosePositionData } from '@shared/utils/Trading/ClosePositionData';
import { ConfirmationTypesEnum } from '@shared/utils/Trading/ConfirmationTypesEnum';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { OrderActionEnum } from '@shared/utils/Trading/OrderActionEnum';
import { TIF } from '@shared/utils/Trading/OrderTif';
import { OrderTif } from '@shared/utils/Trading/OrderTifEnum';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { PositionActionEnum } from '@shared/utils/Trading/PositionActionEnum';
import { PositionCloseReqeustData } from '@shared/utils/Trading/PositionCloseRequestData';
import { TradingLockUtils } from '@shared/utils/TradingLockUtils';
import { Connection } from '../Connection';
import { IsAllowed, IsAllowedResponce } from '../IsAllowed';
import { IsAllowedResponceReason } from '../IsAllowedResponceReason';
import { OrderExecutorUtils } from './OrderExecutorUtils';
import { ApplicationInfo } from '../ApplicationInfo';
import { OrderConfirmation } from './OrderConfirmation';
import { BaseSettingsUtils } from '../UtilsClasses/BaseGeneralSettingsUtilsWrapper';
export class OrderExecutor {
    constructor(dataCache) {
        this.FDataCache = dataCache;
    }
    changeOrdersToMarketPromise(orderIdArray, confirm, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield OrderExecutor.processVendorActionPromise(function () {
                this.changeOrdersToMarketWork(orderIdArray, placedFrom);
            }.bind(this), ConfirmationTypesEnum.Modify, 'panel.orders.menu.ExecuteAsMarket', 'panel.orders.menu.ExecuteAsMarket.question', confirm);
        });
    }
    // TODO. Rename.
    changeOrdersToMarketWork(orderIdArray, placedFrom) {
        const vendor = Connection.vendor;
        const orders = this.FDataCache.Trading.getOrdersById(orderIdArray);
        for (const order of orders) {
            // TODO. Refactor. Remove.
            // Can't change position's closing order type to market.
            if (order.isClosingOrder()) {
                continue;
            }
            OrderConfirmation.createRequestEventMessage([order, placedFrom], OrderConfirmation.CHANGE_TO_MARKET); // Generate and add request event(s) to Event Log
            // TODO. Refactor. Use modifyOrder()?
            vendor.changeOrderToMarket(order, placedFrom);
        }
    }
    modifyOrderPromiseWithCallbacks(orderEditObj_1, yesClickCB_1, noClickCB_1) {
        return __awaiter(this, arguments, void 0, function* (orderEditObj, yesClickCB, noClickCB, onlyAction = false) {
            return yield OrderExecutor.processOrderEditObjectPromise(orderEditObj, Connection.vendor.modifyOrder, ConfirmationTypesEnum.Modify, yesClickCB, noClickCB, onlyAction);
        });
    }
    modifyOrderPromise(orderEditObj) {
        return __awaiter(this, void 0, void 0, function* () {
            if (orderEditObj.account.AccountType !== AccountType.MultiAsset) {
                if (!(orderEditObj === null || orderEditObj === void 0 ? void 0 : orderEditObj.valid()) || !orderEditObj.validSLTP()) {
                    return yield Promise.reject(new Error('bad parameters'));
                }
                else if (!(orderEditObj === null || orderEditObj === void 0 ? void 0 : orderEditObj.valid())) {
                    return yield Promise.reject(new Error('bad parameters'));
                }
            }
            const reqData = orderEditObj.getDataForRequest();
            const vendorActionCallback = Connection.vendor.modifyOrder.bind(Connection.vendor);
            return yield Promise.resolve(vendorActionCallback(reqData));
        });
    }
    modifyPositionPromise(positionEditObj_1) {
        return __awaiter(this, arguments, void 0, function* (positionEditObj, onlyAction = false) {
            return yield OrderExecutor.processOrderEditObjectPromise(positionEditObj, Connection.vendor.modifyPosition, ConfirmationTypesEnum.Modify, null, null, onlyAction);
        });
    }
    WMmodifyPositionPromise(orderEditObj) {
        return __awaiter(this, void 0, void 0, function* () {
            if (orderEditObj.account.AccountType !== AccountType.MultiAsset) {
                if (!(orderEditObj === null || orderEditObj === void 0 ? void 0 : orderEditObj.valid()) || !orderEditObj.validSLTP()) {
                    return yield Promise.reject('bad parameters');
                }
                else if (!(orderEditObj === null || orderEditObj === void 0 ? void 0 : orderEditObj.valid())) {
                    return yield Promise.reject('bad parameters');
                }
            }
            const reqData = orderEditObj.getDataForRequest();
            // TODO. Ugly.
            Connection.vendor.modifyPosition = Connection.vendor.modifyPosition.bind(Connection.vendor);
            OrderConfirmation.createRequestEventMessage(reqData, OrderConfirmation.PLACE_OR_REPLACE); // Generate and add request event(s) to Event Log
            return yield Promise.resolve(Connection.vendor.modifyPosition(reqData));
        });
    }
    placeOrderPromise(orderEditObj_1, confirmationType_1, yesCallBack_1, noCallBack_1) {
        return __awaiter(this, arguments, void 0, function* (orderEditObj, confirmationType, yesCallBack, noCallBack, onlyAction = false) {
            return yield OrderExecutor.processOrderEditObjectPromise(orderEditObj, Connection.vendor.placeOrder, confirmationType || ConfirmationTypesEnum.OrderPlace, yesCallBack, noCallBack, onlyAction);
        });
    }
    placeOrderAsync(orderEditObj) {
        if (!orderEditObj) {
            return Promise.reject(OrderExecutor.BAD_PARAMETERS);
        }
        if (orderEditObj.account.AccountType !== AccountType.MultiAsset &&
            (!orderEditObj.valid() || !orderEditObj.validSLTP())) {
            return Promise.reject(OrderExecutor.BAD_PARAMETERS);
        }
        const requestData = orderEditObj.getDataForRequest();
        return Connection.vendor.placeOrderAsync(requestData);
    }
    multiplyPlaceOrdersAsync(multiplyOrdersWrapper) {
        return Connection.vendor.multiplyPlaceOrdersAsync(multiplyOrdersWrapper);
    }
    // TODO. Rename. Refactor.
    static processOrderEditObjectPromise(orderEditObj_1, vendorActionCallback_1, confirmationType_1) {
        return __awaiter(this, arguments, void 0, function* (orderEditObj, vendorActionCallback, confirmationType, yesClickCB = null, noClickCB = null, onlyAction = false) {
            if (orderEditObj.account.AccountType !== AccountType.MultiAsset) {
                if (!(orderEditObj === null || orderEditObj === void 0 ? void 0 : orderEditObj.valid()) || !orderEditObj.validSLTP()) {
                    return yield Promise.reject('bad parameters');
                }
                else if (!(orderEditObj === null || orderEditObj === void 0 ? void 0 : orderEditObj.valid())) {
                    return yield Promise.reject('bad parameters');
                }
            }
            const reqData = orderEditObj.getDataForRequest();
            vendorActionCallback = vendorActionCallback.bind(Connection.vendor);
            if (onlyAction) {
                OrderConfirmation.createRequestEventMessage(reqData, OrderConfirmation.PLACE_OR_REPLACE); // Generate and add request event(s) to Event Log
                return yield Promise.resolve(vendorActionCallback(reqData));
            }
            // TODO. Ugly.
            const confirmationWarningData = orderEditObj.getConfirmationWarningData();
            const warningText = BaseSettingsUtils.needToShowWarning(confirmationWarningData)
                ? OrderExecutor.toWarningText(confirmationWarningData.warningArray)
                : '';
            if (!BaseSettingsUtils.useConfirmation(confirmationType) && !warningText) {
                OrderConfirmation.createRequestEventMessage(reqData, OrderConfirmation.PLACE_OR_REPLACE); // Generate and add request event(s) to Event Log
                if (yesClickCB) {
                    yesClickCB();
                }
                return yield Promise.resolve(vendorActionCallback(reqData));
            }
            const needToShowWarningForcefully = orderEditObj.needToShowWarningForcefully(); // when warning was shown forcefully it can't be changed in Confirmations Settings #110665
            // TODO. Refactor. Promisify MessageBox.
            return yield new Promise(function (resolve, reject) {
                const okCallback = (showNextTime) => {
                    BaseSettingsUtils.updateConfirmation(confirmationType, showNextTime);
                    OrderConfirmation.createRequestEventMessage(reqData, OrderConfirmation.PLACE_OR_REPLACE); // Generate and add request event(s) to Event Log
                    if (yesClickCB) {
                        yesClickCB();
                    }
                    resolve(vendorActionCallback(reqData));
                };
                const cancelCallback = (showNextTime) => {
                    BaseSettingsUtils.updateConfirmation(confirmationType, showNextTime);
                    if (noClickCB) {
                        noClickCB();
                    }
                    reject('cancell clicked');
                };
                confirmationScreenHandler.Show(confirmationType, reqData, messageBoxHandler.msgType.Question, okCallback, cancelCallback, !needToShowWarningForcefully, false, warningText, undefined, undefined, OrderExecutor.getConfirmationExtraData(orderEditObj));
            });
        });
    }
    static getConfirmationExtraData(orderEditObj) {
        return __awaiter(this, void 0, void 0, function* () {
            const confirmationData = yield orderEditObj.getConfirmationData();
            const reqData = orderEditObj.getDataForRequest();
            return {
                reqData,
                warningText: BaseSettingsUtils.needToShowWarning(confirmationData)
                    ? OrderExecutor.toWarningText(confirmationData.warningArray)
                    : ''
            };
        });
    }
    // TODO. Rename. Refactor. Ugly.
    static processVendorActionPromise(vendorActionCallback_1, confirmationType_1, confirmationHeaderKey_1, confirmationText_1) {
        return __awaiter(this, arguments, void 0, function* (vendorActionCallback, confirmationType, confirmationHeaderKey, confirmationText, confirmNeeded = true, eventLogRequstHandler, orders) {
            if (!confirmNeeded || !BaseSettingsUtils.useConfirmation(confirmationType)) {
                if (eventLogRequstHandler) {
                    eventLogRequstHandler();
                }
                vendorActionCallback();
                return yield Promise.resolve(true);
            }
            // TODO. Refactor. Promisify MessageBox.
            return yield new Promise(function (resolve, reject) {
                const okCallback = (showNextTime) => {
                    BaseSettingsUtils.updateConfirmation(confirmationType, showNextTime);
                    if (eventLogRequstHandler) {
                        eventLogRequstHandler();
                    }
                    vendorActionCallback();
                    resolve(true);
                };
                const cancelCallback = (showNextTime) => {
                    resolve(false);
                    BaseSettingsUtils.updateConfirmation(confirmationType, showNextTime);
                };
                if (orders == null) {
                    messageBoxHandler.Show(Resources.getResource(confirmationHeaderKey), Resources.getResource(confirmationText), messageBoxHandler.msgType.Question, okCallback, cancelCallback, true, false);
                }
                else {
                    confirmationScreenHandler.Show(confirmationType, orders, messageBoxHandler.msgType.Question, okCallback, cancelCallback, true, false);
                }
            });
        });
    }
    cancelOrdersByIdPromise(orderIdArray, confirm, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const orders = this.FDataCache.Trading.getOrdersById(orderIdArray);
            return yield this.cancelOrdersPromise(orders, confirm, placedFrom);
        });
    }
    cancelOrdersPromise(orders, confirm, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const question = `${Resources.getResource('orders.confirm.all.question1')}${orders.length}${Resources.getResource('orders.confirm.all.question2')}`;
            return yield this.processCancelOrders(orders, placedFrom, question, confirm);
        });
    }
    cancelOrdersByAccountPromise(account, confirm, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const orders = this.FDataCache.Trading.getOrdersByAccount(account);
            return yield this.processCancelOrders(orders, placedFrom, 'chart.menu.cancelByAccount', confirm);
        });
    }
    cancelOrdersByInstrumentPromise(instrument, confirm, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const orders = this.FDataCache.Trading.getOrdersByInstrument(instrument);
            return yield this.processCancelOrders(orders, placedFrom, 'orders.confirm.cancel.question1', confirm);
        });
    }
    cancelOrdersByInstrumentAndAccountPromise(instrument, account, confirm, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const orders = this.FDataCache.Trading.getOrdersByInstrumentAndAccount(instrument, account);
            return yield this.processCancelOrders(orders, placedFrom, 'orders.confirm.cancel.question1', confirm);
        });
    }
    cancelAllOrdersPromise(confirm, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const orders = this.FDataCache.Trading.getAllOrders();
            return yield this.processCancelOrders(orders, placedFrom, 'orders.confirm.all.title', confirm);
        });
    }
    // TODO. Rename.
    cancelSelectedOrders(orders, placedFrom) {
        if (orders.length === 0)
            return;
        OrderConfirmation.createRequestEventMessage([orders, placedFrom]); // Generate and add request event(s) to Event Log
        const vendor = Connection.vendor;
        for (const order of orders) {
            vendor.cancelOrder(order, placedFrom);
        }
    }
    closePositionsByIdPromise(positionIdArray, confirm, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirm && BaseSettingsUtils.useConfirmation(ConfirmationTypesEnum.PositionClose)) {
                for (let i = 0, len = positionIdArray.length; i < len; i++) {
                    editPositionScreenHandler.show(positionIdArray[i], placedFrom, null, false);
                }
            }
            else {
                this.closeSelectedPositions(this.FDataCache.Trading.getPositionsById(positionIdArray), placedFrom);
            }
            yield Promise.resolve();
        });
    }
    // TODO. Rename.
    closeSelectedPositions(positions, placedFrom, mutualPositionID) {
        if (positions.length === 0)
            return;
        OrderConfirmation.createRequestEventMessage([positions, mutualPositionID, placedFrom]); // Generate and add request event(s) to Event Log
        const closePositionsData = [];
        for (const position of positions) {
            closePositionsData.push(new ClosePositionData(position, this.getTifForClosingOrder(position), new Quantity(position.Amount, true), BaseSettingsUtils.isAllowOTHTradingByDefault(position.Account, position.Instrument), mutualPositionID));
        }
        void Connection.vendor.closePositions(closePositionsData, placedFrom);
    }
    createPositionClosingRejectedMessage(position, reason) {
        if (isNullOrUndefined(position)) {
            return;
        }
        const positionId = position.PositionId;
        const rejectionMessage = Resources.getResource('reports.Position closing rejected', [positionId]);
        const reportMessage = new DirectReportMessage(rejectionMessage, [['Error', reason !== null && reason !== void 0 ? reason : rejectionMessage]]);
        reportMessage.Instrument = position.Instrument;
        reportMessage.account = position.Account;
        reportMessage.reject = true;
        reportMessage.tooltipDrawType = TooltipType.Trade;
        this.FDataCache.NewMessage(reportMessage);
    }
    closePositionQuantity(position, quantityToClose, isAllowOTHTrading, placedFrom) {
        const positionCloseRequestData = new PositionCloseReqeustData(position, quantityToClose, isAllowOTHTrading, placedFrom);
        OrderConfirmation.createRequestEventMessage(positionCloseRequestData); // Generate and add request event(s) to Event Log
        const closePositionData = new ClosePositionData(position, this.getTifForClosingOrder(position), quantityToClose, isAllowOTHTrading);
        void Connection.vendor.closePositions([closePositionData], placedFrom);
    }
    closeAllPositionsPromise(confirm, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const positionIds = this.FDataCache.Trading.getAllPositionIds();
            yield this.closePositionsByIdPromise(positionIds, confirm, placedFrom);
        });
    }
    getTifForClosingOrder(position) {
        const route = this.FDataCache.Routes.getRouteByName(position.Route);
        for (const tif of [OrderTif.Day, OrderTif.IOC, OrderTif.GTC, OrderTif.GTD]) {
            if (route === null || route === void 0 ? void 0 : route.IsAllowableTif(tif, OrderType.Market)) {
                if (tif === OrderTif.GTD) {
                    const expirationDate = new Date();
                    expirationDate.setUTCFullYear(expirationDate.getUTCFullYear() + 1);
                    return new TIF(tif, expirationDate);
                }
                else {
                    return new TIF(tif);
                }
            }
        }
        return new TIF(OrderTif.Day);
    }
    orderAction(action, isFiltered, selectedOrderIdArray, allOrderIdArray, confirm, placedFrom, numericLinkName) {
        return __awaiter(this, void 0, void 0, function* () {
            selectedOrderIdArray = selectedOrderIdArray || [];
            const dc = this.FDataCache;
            const firstSelectedOrderId = selectedOrderIdArray[0] || null;
            const firstSelectedOrder = dc.Trading.getOrderById(firstSelectedOrderId);
            const acc = firstSelectedOrder ? firstSelectedOrder.Account : null;
            const ins = firstSelectedOrder ? firstSelectedOrder.Instrument : null;
            const actions = OrderActionEnum;
            switch (action) {
                case actions.ModifyOrder:
                    this.orderActionModifyOrder(selectedOrderIdArray, placedFrom, numericLinkName);
                    break;
                case actions.All:
                    isFiltered
                        ? yield this.cancelOrdersByIdPromise(allOrderIdArray, confirm, placedFrom)
                        : yield this.cancelAllOrdersPromise(confirm, placedFrom);
                    break;
                case actions.ByIds:
                    yield this.cancelOrdersByIdPromise(selectedOrderIdArray, confirm, placedFrom);
                    break;
                case actions.ByAccountAndInstrument:
                    yield this.cancelOrdersByInstrumentAndAccountPromise(ins, acc, confirm, placedFrom);
                    break;
                case actions.ByInstrument:
                    yield this.cancelOrdersByInstrumentPromise(ins, confirm, placedFrom);
                    break;
                case actions.ByAccount:
                    yield this.cancelOrdersByAccountPromise(acc, confirm, placedFrom);
                    break;
                // TODO. Refactor. Confirmation isn't needed for these actions yet.
                case actions.Sell:
                    this.cancelSelectedOrders(this.filterOrders(dc.Trading.getOrdersBySide(OperationType.Sell), isFiltered, allOrderIdArray), placedFrom);
                    break;
                case actions.Buy:
                    this.cancelSelectedOrders(this.filterOrders(dc.Trading.getOrdersBySide(OperationType.Buy), isFiltered, allOrderIdArray), placedFrom);
                    break;
                case actions.Stops:
                    this.cancelSelectedOrders(this.filterOrders(dc.Trading.getOrdersByType(OrderType.Stop), isFiltered, allOrderIdArray), placedFrom);
                    break;
                case actions.Limits:
                    this.cancelSelectedOrders(this.filterOrders(dc.Trading.getOrdersByType(OrderType.Limit), isFiltered, allOrderIdArray), placedFrom);
                    break;
                case actions.Days:
                    this.cancelSelectedOrders(this.filterOrders(dc.Trading.getOrdersByTIF(OrderTif.Day), isFiltered, allOrderIdArray), placedFrom);
                    break;
                case actions.GTCs:
                    this.cancelSelectedOrders(this.filterOrders(dc.Trading.getOrdersByTIF(OrderTif.GTC), isFiltered, allOrderIdArray), placedFrom);
                    break;
                case actions.ChangeToMarket:
                    yield this.changeOrdersToMarketPromise(selectedOrderIdArray, confirm, placedFrom);
                    break;
                default:
                    console.error('missing order action');
            }
        });
    }
    filterOrders(orders, isFiltered, filteredOrdersId) {
        if (!isFiltered) {
            return orders;
        }
        const filteredOrderIdSet = new Set(filteredOrdersId);
        return orders.filter((order) => filteredOrderIdSet.has(order.OrderNumber));
    }
    orderActionModifyOrder(selectedOrderIdArray, placedFrom, numericLinkName) {
        const dc = this.FDataCache;
        const len = selectedOrderIdArray.length;
        for (let i = 0; i < len; i++) {
            const orderId = selectedOrderIdArray[i];
            const order = dc.Trading.getOrderById(orderId);
            if (!order)
                continue;
            if (order.Active) {
                modifyOrderScreenHandler.show(orderId, placedFrom, numericLinkName);
            }
            else {
                editPositionScreenHandler.show(order.PositionId, placedFrom, numericLinkName, true);
            }
        }
    }
    // TODO. Pass PlacedFrom to a vendor.
    positionAction(action, isFiltered, selectedPositionIdArray, allPositionsIdArray, confirm, placedFrom, numericLinkName) {
        return __awaiter(this, void 0, void 0, function* () {
            selectedPositionIdArray = selectedPositionIdArray || [];
            const dc = this.FDataCache;
            const firstSelectedPositionId = selectedPositionIdArray[0] || null;
            const firstSelectedPos = dc.Trading.getPositionById(firstSelectedPositionId);
            const acc = firstSelectedPos ? firstSelectedPos.Account : null;
            const ins = firstSelectedPos ? firstSelectedPos.Instrument : null;
            const actions = PositionActionEnum;
            switch (action) {
                case actions.PositionModifying:
                    this.orderActionModifyPosition(selectedPositionIdArray, placedFrom, numericLinkName);
                    break;
                case actions.ModifyProductType:
                    this.orderActionModifyPosition([firstSelectedPositionId], placedFrom, numericLinkName);
                    break;
                case actions.ExerciseOption:
                    this.exercisePositionRequestScreenShow(firstSelectedPos, placedFrom);
                    break;
                case actions.ExerciseCancel:
                    this.exercisePositionCancel(firstSelectedPos, placedFrom);
                    break;
                case actions.ClosePositionMkt:
                    yield this.closePositionsByIdPromise(selectedPositionIdArray, confirm, placedFrom);
                    break;
                case actions.All:
                    this.closeSelectedPositions(this.filterPositions(dc.Trading.getAllPositions(), isFiltered, allPositionsIdArray), placedFrom);
                    break;
                case actions.CLXAll:
                    this.closeSelectedPositions(dc.Trading.getAllPositions(), placedFrom);
                    this.cancelSelectedOrders(dc.Trading.getAllOrders(), placedFrom);
                    break;
                case actions.CLXByAccountAndInstrument:
                    this.closeSelectedPositions(dc.Trading.getPositionsByInstrumentAndAccount(ins, acc), placedFrom);
                    this.cancelSelectedOrders(dc.Trading.getOrdersByInstrumentAndAccount(ins, acc), placedFrom);
                    break;
                case actions.ByAccountAndInstrument:
                    this.closeSelectedPositions(dc.Trading.getPositionsByInstrumentAndAccount(ins, acc), placedFrom);
                    break;
                case actions.Short:
                    this.closeSelectedPositions(this.filterPositions(dc.Trading.getPositionsBySide(OperationType.Sell), isFiltered, allPositionsIdArray), placedFrom);
                    break;
                case actions.Long:
                    this.closeSelectedPositions(this.filterPositions(dc.Trading.getPositionsBySide(OperationType.Buy), isFiltered, allPositionsIdArray), placedFrom);
                    break;
                case actions.Negative:
                    this.closeSelectedPositions(this.filterPositions(dc.Trading.getPositionsByNetPL(false), isFiltered, allPositionsIdArray), placedFrom);
                    break;
                case actions.Positive:
                    this.closeSelectedPositions(this.filterPositions(dc.Trading.getPositionsByNetPL(true), isFiltered, allPositionsIdArray), placedFrom);
                    break;
                case actions.Mutual:
                    this.mutualClosingPositions(selectedPositionIdArray, placedFrom);
                    break;
                case actions.ReverseByInstrument:
                    void this.reversePositions(dc.Trading.getPositionsByInstrumentAndAccount(ins, acc), placedFrom);
                    break;
                case actions.ReverseByIds:
                    void this.reversePositions(dc.Trading.getPositionsById(selectedPositionIdArray), placedFrom);
                    break;
                default:
                    console.error('missing position action');
            }
        });
    }
    filterPositions(positions, isFiltered, filteredPositionsId) {
        if (!isFiltered) {
            return positions;
        }
        const filteredPositionIdSet = new Set(filteredPositionsId);
        return positions.filter((position) => filteredPositionIdSet.has(position.PositionId));
    }
    orderActionModifyPosition(selectedPositionIdArray, placedFrom, numericLinkName) {
        const len = selectedPositionIdArray.length;
        for (let i = 0; i < len; i++) {
            editPositionScreenHandler.show(selectedPositionIdArray[i], placedFrom, numericLinkName, true);
        }
    }
    reversePositions(positions, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const promises = [];
            for (const position of positions) {
                promises.push(this.reversePosition(position, placedFrom));
            }
            return yield Promise.all(promises);
        });
    }
    reversePosition(position, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const { DataCache, Account: acc, Instrument: ins } = position;
            OrderConfirmation.createRequestEventMessage([position, placedFrom], OrderConfirmation.REVERSE_POSITION); // Generate and add request event(s) to Event Log
            const data = position.GetOrderEditRequestData();
            data.orderTypeId = OrderType.Market;
            data.tif = this.getTifForClosingOrder(position);
            data.placedFrom = placedFrom;
            if (ins.LastQuote != null) {
                const spreadPlan = DataCache.GetSpreadPlan(acc);
                const bid = ins.LastQuote.BidSpread_SP_Ins(spreadPlan, ins);
                const ask = ins.LastQuote.AskSpread_SP_Ins(spreadPlan, ins);
                const isBuy = position.BuySell === OperationType.Buy;
                data.parameterDict.limitPrice = isBuy ? bid : ask;
                data.parameterDict.stopPrice = isBuy ? ask : bid;
            }
            else {
                data.parameterDict.limitPrice = position.CurPriceClose;
                data.parameterDict.stopPrice = position.Price;
            }
            return yield Connection.vendor.reversePosition(data);
        });
    }
    modifyPositionProductType(positionEditObj) {
        return __awaiter(this, void 0, void 0, function* () {
            const confirm = BaseSettingsUtils.useConfirmation(ConfirmationTypesEnum.Modify);
            const pos = positionEditObj.position;
            let quantity = positionEditObj.getQuantity();
            const newProductType = positionEditObj.getNewProductType();
            if (!pos || pos.ProductType === undefined) {
                return;
            }
            const eventloghandler = () => {
                this.createRequestEventMessageModifyProductType(positionEditObj);
            };
            const inLots = BaseSettingsUtils.displayAmountInLots();
            quantity = Quantity.toLots(new Quantity(quantity, inLots), pos.Instrument);
            return yield OrderExecutor.processVendorActionPromise(function () {
                Connection.vendor.modifyPositionProductType(pos, newProductType, quantity);
            }, ConfirmationTypesEnum.Modify, 'general.trading.confirmation', OrderExecutorUtils.buildPositionModifyProductTypeConfirmationText(pos, newProductType, quantity), confirm, eventloghandler);
        });
    }
    mutualClosingPositions(positionsIdArray, placedFrom) {
        positionsMutualCloseScreenHandler.show(positionsIdArray, placedFrom, this.closeSelectedPositions.bind(this));
    }
    exercisePositionRequestScreenShow(pos, placedFrom) {
        if (!pos) {
            return;
        }
        positionExerciseRequestScreenHandler.show(pos, placedFrom);
    }
    exercisePositionCancel(pos, placedFrom) {
        if (!pos) {
            return;
        }
        const okCallback = (showNextTime) => {
            this.FDataCache.CancelExerciseByPosition(pos, placedFrom);
        };
        const cancelCallback = (showNextTime) => {
            // -- nothing
        };
        const confirmLocKey = 'screen.PositionExerciseCancelConfirm.text';
        const confirmText = Resources.getResource(confirmLocKey);
        messageBoxHandler.Show('', confirmText.replace('{1}', pos.PositionId), messageBoxHandler.msgType.Question, okCallback, cancelCallback, false, // show next time cb
        false);
    }
    createRequestEventMessageModifyProductType(reqData) {
        const header = Resources.getResource('reports.Product type modification request');
        // let panelId = reqData.placedFrom
        const acc = reqData.account;
        const ins = reqData.instrument;
        const pos = reqData.position;
        const qty = reqData.getQuantity();
        const productType = pos.ProductType;
        const productTypeInitStr = InstrumentUtils.GetLocalizedProductType(ins, productType);
        const productTypeTargetStr = InstrumentUtils.GetLocalizedProductType(ins, reqData.getNewProductType());
        const inLots = BaseSettingsUtils.displayAmountInLots();
        const quantity = new Quantity(qty, inLots);
        let qtValue = null;
        if (quantity && ins) {
            qtValue = Quantity.toLots(quantity, ins);
        }
        const user = { Label: 'User', Value: acc ? acc.userLogin : null };
        const account = { Label: 'Account', Value: acc ? acc.FullAccString : null };
        const positionId = { Label: 'Position ID', Value: pos.PositionId != -1 ? pos.PositionId : '' };
        const instrument = { Label: 'Instrument', Value: ins ? ins.DisplayShortName() : '' };
        // route = { Label: 'Route', Value: ''/*obj.Route ? DataCache.Routes.getRouteById(obj.Route).Name : (ins ? DataCache.Routes.getRouteById(ins.Route).Name : "")*/ },      // #85093
        const amount = { Label: 'Amount', Value: qtValue !== null ? qtValue : '' };
        const time = { Label: 'Time', Value: Date.now().toString() };
        // clientPanelId = { Label: 'Send from', Value: 'reports.' + Utils.getKeyByValue(OrderExecutor.PlacedFrom, panelId) },
        const productTypeInit = { Label: 'Initial product type', Value: productTypeInitStr };
        const productTypeTarget = { Label: 'Target product type', Value: productTypeTargetStr };
        const selectedLabels = [
            user,
            account,
            positionId,
            instrument /* route */,
            ,
            amount,
            productTypeInit,
            productTypeTarget /* clientPanelId */,
            ,
            time
        ];
        const resultDataArr = [];
        const len = selectedLabels.length;
        for (let i = 0; i < len; i++) {
            const lbl = selectedLabels[i];
            if (lbl && (lbl.Value || lbl.Value === 0)) {
                resultDataArr.push([lbl.Label, lbl.Value]);
            }
        }
        const reportMessage = new DirectReportMessage(header, resultDataArr);
        reportMessage.SkipOnTicketViewer = true; // чтобы не показывать в TicketViewer
        reportMessage.Instrument = ins;
        reportMessage.productType = productType;
        reportMessage.account = acc;
        this.FDataCache.NewMessage(reportMessage);
    }
    createEventMessageProductTypeModified(position, modifiedAmount) {
        const header = Resources.getResource('reports.Product type modified');
        // let panelId = reqData.placedFrom
        const acc = position.Account;
        const ins = position.Instrument;
        const productType = position.ProductType;
        const productTypeStr = InstrumentUtils.GetLocalizedProductType(ins, productType);
        const qty = modifiedAmount || position.Amount;
        const quantity = new Quantity(qty, true);
        let qtValue = null;
        if (quantity && ins) {
            qtValue = Quantity.toLots(quantity, ins);
        }
        const user = { Label: 'User', Value: acc ? acc.userLogin : null };
        const account = { Label: 'Account', Value: acc ? acc.FullAccString : null };
        const positionId = { Label: 'Position ID', Value: position.PositionId != -1 ? position.PositionId : '' };
        const instrument = { Label: 'Instrument', Value: ins ? ins.DisplayShortName() : '' };
        // route = { Label: 'Route', Value: ''/*obj.Route ? DataCache.Routes.getRouteById(obj.Route).Name : (ins ? DataCache.Routes.getRouteById(ins.Route).Name : "")*/ },      // #85093
        const amount = { Label: 'Amount', Value: qtValue !== null ? qtValue : '' };
        // time = { Label: 'Time', Value: Date.now().toString() },
        // clientPanelId = { Label: 'Send from', Value: 'reports.' + Utils.getKeyByValue(OrderExecutor.PlacedFrom, panelId) },
        const productTypeRow = { Label: 'Product type', Value: productTypeStr };
        const selectedLabels = [user, account, positionId, instrument /* route */, , amount, productTypeRow];
        const resultDataArr = [];
        const len = selectedLabels.length;
        for (let i = 0; i < len; i++) {
            const lbl = selectedLabels[i];
            if (lbl && (lbl.Value || lbl.Value === 0)) {
                resultDataArr.push([lbl.Label, lbl.Value]);
            }
        }
        const reportMessage = new DirectReportMessage(header, resultDataArr);
        // reportMessage.SkipOnTicketViewer = true          // чтобы не показывать в TicketViewer
        reportMessage.Instrument = ins;
        reportMessage.account = acc;
        reportMessage.productType = productType;
        this.FDataCache.NewMessage(reportMessage);
    }
    static toWarningText(warningArray) {
        return OrderExecutorUtils.formatWarningText(warningArray);
    }
    // TODO. Refactor?
    getAllowedOrderActionSet(selectedOrderIdArray = [], allRowsIds = [], isFiltered = false) {
        const resActionSet = {};
        const actions = Enum.TakeKeysFromEnum(OrderActionEnum);
        if (TradingLockUtils.TradingLock.tradingLocked) {
            for (const key of actions) {
                const notAllowedReason = ApplicationInfo.isExploreMode
                    ? IsAllowedResponceReason.NotAllowedByExploreMode
                    : IsAllowedResponceReason.LockTrading;
                resActionSet[OrderActionEnum[key]] = IsAllowedResponce.NotAllowedResponce(notAllowedReason);
            }
            return resActionSet;
        }
        const dc = this.FDataCache;
        const orders = isFiltered ? dc.Trading.getOrdersById(allRowsIds) : dc.Trading.getAllOrders();
        const firstSelectedOrder = dc.Trading.getOrderById(selectedOrderIdArray[0]);
        for (const order of orders) {
            if (order.BuySell === OperationType.Buy) {
                resActionSet[OrderActionEnum.Buy] = IsAllowedResponce.AllowedResponce();
            }
            if (order.BuySell === OperationType.Sell) {
                resActionSet[OrderActionEnum.Sell] = IsAllowedResponce.AllowedResponce();
            }
            if (order.OrderType === OrderType.Stop) {
                resActionSet[OrderActionEnum.Stops] = IsAllowedResponce.AllowedResponce();
            }
            if (order.OrderType === OrderType.Limit) {
                resActionSet[OrderActionEnum.Limits] = IsAllowedResponce.AllowedResponce();
            }
            if (order.TimeInForce === OrderTif.GTC) {
                resActionSet[OrderActionEnum.GTCs] = IsAllowedResponce.AllowedResponce();
            }
            if (order.TimeInForce === OrderTif.Day) {
                resActionSet[OrderActionEnum.Days] = IsAllowedResponce.AllowedResponce();
            }
        }
        const orderCount = orders.length;
        if (orderCount > 0) {
            resActionSet[OrderActionEnum.All] = IsAllowed.IsCloseAllAllowed(false);
        }
        if (!isNullOrUndefined(firstSelectedOrder)) {
            const allowedCancel = IsAllowed.IsOrderCancelingAllowed(firstSelectedOrder);
            resActionSet[OrderActionEnum.ByIds] = allowedCancel;
            resActionSet[OrderActionEnum.ByAccount] = IsAllowed.IsOrderCancelingAllowed(firstSelectedOrder, undefined, undefined, true); // ignoreCheckBySymbol
            resActionSet[OrderActionEnum.ByInstrument] = IsAllowed.IsOrderCancelingAllowed(firstSelectedOrder, undefined, true); // ignoreCheckByAccount
            resActionSet[OrderActionEnum.ByAccountAndInstrument] = allowedCancel;
            resActionSet[OrderActionEnum.ModifyOrder] = IsAllowed.IsOrderModifyingAllowed(firstSelectedOrder);
        }
        const changeToMarket = !(selectedOrderIdArray.length === 0);
        if (changeToMarket) {
            resActionSet[OrderActionEnum.ChangeToMarket] = IsAllowed.IsOrderExecutingAllowed(firstSelectedOrder);
        }
        return resActionSet;
    }
    // TODO. Refactor?
    getAllowedPositionActionSet(selectedPositionIdArray = [], allRowsIds = [], isFiltered = false) {
        const resActionSet = {};
        const actions = Enum.TakeKeysFromEnum(PositionActionEnum);
        if (TradingLockUtils.TradingLock.tradingLocked) {
            for (const key of actions) {
                const notAllowedReason = ApplicationInfo.isExploreMode
                    ? IsAllowedResponceReason.NotAllowedByExploreMode
                    : IsAllowedResponceReason.LockTrading;
                resActionSet[PositionActionEnum[key]] = IsAllowedResponce.NotAllowedResponce(notAllowedReason);
            }
            return resActionSet;
        }
        const dc = this.FDataCache;
        const positions = isFiltered ? dc.Trading.getPositionsById(allRowsIds) : dc.Trading.getAllPositions();
        const positionsForClx = dc.Trading.getAllPositions();
        const orders = dc.Trading.getAllOrders();
        const selectedPositions = dc.Trading.getPositionsById(selectedPositionIdArray);
        const firstSelectedPos = dc.Trading.getPositionById(selectedPositionIdArray[0]);
        for (const pos of positions) {
            pos.PnLCalculator.NetPL < 0
                ? (resActionSet[PositionActionEnum.Negative] = IsAllowedResponce.AllowedResponce())
                : (resActionSet[PositionActionEnum.Positive] = IsAllowedResponce.AllowedResponce());
            if (pos.BuySell === OperationType.Buy) {
                resActionSet[PositionActionEnum.Long] = IsAllowedResponce.AllowedResponce();
            }
            if (pos.BuySell === OperationType.Sell) {
                resActionSet[PositionActionEnum.Short] = IsAllowedResponce.AllowedResponce();
            }
        }
        const posLen = positions.length;
        const CLXPosLen = isFiltered ? positionsForClx.length : posLen;
        const ordLen = orders.length;
        if (posLen !== 0) {
            resActionSet[PositionActionEnum.All] = IsAllowedResponce.AllowedResponce();
        }
        if (CLXPosLen !== 0 || ordLen !== 0) {
            resActionSet[PositionActionEnum.CLXAll] = IsAllowedResponce.AllowedResponce();
        }
        if (!isNullOrUndefined(firstSelectedPos)) {
            resActionSet[PositionActionEnum.ByAccountAndInstrument] = IsAllowedResponce.AllowedResponce();
            resActionSet[PositionActionEnum.CLXByAccountAndInstrument] = IsAllowedResponce.AllowedResponce();
            resActionSet[PositionActionEnum.PositionModifying] = IsAllowed.IsPositionModifyingAllowed(firstSelectedPos);
            resActionSet[PositionActionEnum.ModifyProductType] =
                IsAllowed.IsPositionProductTypeModifyingAllowed(selectedPositions);
            // return ExerciseCancelAllowStruct
            resActionSet[PositionActionEnum.ExerciseCancel] =
                IsAllowed.IsPositionExerciseCancelAllowed(selectedPositions);
            resActionSet[PositionActionEnum.ExerciseCancelVisibility] =
                IsAllowed.IsPositionExerciseCancelVisible(selectedPositions);
            resActionSet[PositionActionEnum.ExerciseOption] =
                IsAllowed.IsPositionExerciseOptionAllowed(selectedPositions);
        }
        resActionSet[PositionActionEnum.ReverseByInstrument] = IsAllowed.IsPositionReversingAllowed(firstSelectedPos, true); // IsAllowed.IsPositionsReversingAllowed(dc.Trading.getPositionsByInstrument(firstSelectedPos?.Instrument));
        resActionSet[PositionActionEnum.ReverseByIds] = IsAllowed.IsPositionsReversingAllowed(selectedPositions);
        return resActionSet;
    }
    static getBuySell(bs) {
        bs = bs.toLowerCase();
        if (!bs) {
            return -1;
        }
        switch (bs) {
            case 'buy':
                return OperationType.Buy;
            case 'sell':
                return OperationType.Sell;
            // case "sell short":
            //    return VALUE_SELLSHT;
        }
        if (bs.indexOf('buy') > -1) {
            return OperationType.Buy;
        }
        if (bs.indexOf('sell') > -1) {
            return OperationType.Sell;
        }
        return 0;
    }
    static getOrderTypeByName(name) {
        let typeInt = 0;
        name = name.toLowerCase();
        if (OrderExecutor.orderTypeDictionary[name]) {
            typeInt = OrderExecutor.orderTypeDictionary[name];
        }
        return typeInt;
    }
    static Localize() {
        if (Object.keys(OrderExecutor.orderTypeDictionary).length > 0) {
            return;
        }
        OrderExecutor.orderTypeDictionary[Resources.getResourceLang('Limit', LOCALE_EN).toLowerCase()] =
            OrderType.Limit;
        OrderExecutor.orderTypeDictionary[Resources.getResourceLang('Manual', LOCALE_EN).toLowerCase()] =
            OrderType.Manual;
        OrderExecutor.orderTypeDictionary[Resources.getResourceLang('Market', LOCALE_EN).toLowerCase()] =
            OrderType.Market;
        OrderExecutor.orderTypeDictionary[Resources.getResourceLang('OCO', LOCALE_EN).toLowerCase()] = OrderType.OCO;
        OrderExecutor.orderTypeDictionary[Resources.getResourceLang('Stop', LOCALE_EN).toLowerCase()] = OrderType.Stop;
        OrderExecutor.orderTypeDictionary[Resources.getResourceLang('Stop Limit', LOCALE_EN).toLowerCase()] =
            OrderType.StopLimit;
        OrderExecutor.orderTypeDictionary[Resources.getResourceLang('Tr. stop', LOCALE_EN).toLowerCase()] =
            OrderType.TrailingStop;
        OrderExecutor.orderTypeDictionary[Resources.getResourceLang('Stop-loss', LOCALE_EN).toLowerCase()] =
            OrderType.SLTPStop;
        OrderExecutor.orderTypeDictionary[Resources.getResourceLang('Take-profit', LOCALE_EN).toLowerCase()] =
            OrderType.SLTPLimit;
        OrderExecutor.orderTypeDictionary[Resources.getResourceLang('tr. stop', LOCALE_EN).toLowerCase()] =
            OrderType.TRStop;
        OrderExecutor.orderTypeDictionary[Resources.getResourceLang('Care', LOCALE_EN).toLowerCase()] = OrderType.Care;
    }
    processCancelOrders(orders, placedFrom, confirmationText, confirm) {
        return __awaiter(this, void 0, void 0, function* () {
            const ordersNum = orders.length;
            if (ordersNum === 0) {
                return;
            }
            return yield OrderExecutor.processVendorActionPromise(() => {
                this.cancelSelectedOrders(orders, placedFrom);
            }, ConfirmationTypesEnum.OrderCancel, 'panel.orders.menu.Remove', confirmationText, confirm, null, ordersNum > 1 ? null : orders);
        });
    }
}
OrderExecutor.BAD_PARAMETERS = 'bad parameters';
OrderExecutor.orderTypeDictionary = {};
Resources.AddStaticLocalization(OrderExecutor.Localize);
